import { useEffect } from "react";

type Props = {
    vidalyticsId: string,
    vidalyticsUrl: string,
};

const TestimonialVideo = ({
    vidalyticsId,
    vidalyticsUrl,
}: Props) => {

    useEffect(() => {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.innerHTML = `
              (function (v, i, d, a, l, y, t, c, s) {
            y='_'+d.toLowerCase();c=d+'L';if(!v[d]){v[d]={};}if(!v[c]){v[c]={};}if(!v[y]){v[y]={};}var vl='Loader',vli=v[y][vl],vsl=v[c][vl + 'Script'],vlf=v[c][vl + 'Loaded'],ve='Embed';
            if (!vsl){vsl=function(u,cb){
                if(t){cb();return;}s=i.createElement("script");s.type="text/javascript";s.async=1;s.src=u;
                if(s.readyState){s.onreadystatechange=function(){if(s.readyState==="loaded"||s.readyState=="complete"){s.onreadystatechange=null;vlf=1;cb();}};}else{s.onload=function(){vlf=1;cb();};}
                i.getElementsByTagName("head")[0].appendChild(s);
            };}
            vsl(l+'loader.min.js',function(){if(!vli){var vlc=v[c][vl];vli=new vlc();}vli.loadScript(l+'player.min.js',function(){var vec=v[d][ve];t=new vec();t.run(a);});});
        })(window, document, 'Vidalytics', '${vidalyticsId}', '${vidalyticsUrl}');
            `;
        document.body.appendChild(script);
      

        return () => {
            document.body.removeChild(script);
        };
    }, [vidalyticsId, vidalyticsUrl]);

    return (
        <section id="testimonial-video" className="gg-bg-solid-green-light">
            <div className="container-fluid pt-4 pb-4 text-center">
                <div className="row align-items-center justify-content-center">
                    <div className="col-md-9 col-sm-10 col-11">
                        <div id={vidalyticsId}></div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TestimonialVideo;